/* ============================================================
   WOOVO buy box
   - one design chosen per paddle in a set (mix and match)
   - tier pricing shown in the UI; the real discount is applied
     at checkout by the automatic discount / Shopify Function
   - adds one line item per paddle, joined by a shared _set_id
   ============================================================ */
(function () {
  'use strict';

  function money(cents, format) {
    var amount = (cents / 100).toFixed(2);
    amount = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}').replace(/\{\{\s*amount\S*\s*\}\}/, amount);
  }

  function WoovoBuybox(root) {
    this.root = root;
    var raw = root.querySelector('[data-woovo-data]');
    if (!raw) return;

    var data = JSON.parse(raw.textContent);
    this.variants = data.variants;
    this.tiers = data.tiers;
    this.moneyFormat = data.moneyFormat;
    this.singleVariant = !!data.singleVariant;
    this.savingsAs = data.savingsAs || 'percent';
    this.cartUrl = data.cartUrl;
    if (!this.variants.length || !this.tiers.length) return;

    this.el = {
      stage: root.querySelector('[data-stage]'),
      tag: root.querySelector('[data-stage-tag]'),
      thumbs: root.querySelector('[data-thumbs]'),
      swatches: root.querySelectorAll('[data-swatch]'),
      tierEls: root.querySelectorAll('[data-tier]'),
      tierVal: root.querySelector('[data-tier-val]'),
      designLabel: root.querySelector('[data-design-label]'),
      optVal: root.querySelector('[data-opt-val]'),
      slots: root.querySelector('[data-slots]'),
      mixnote: root.querySelector('[data-mixnote]'),
      vdesc: root.querySelector('[data-vdesc]'),
      priceNow: root.querySelector('[data-price-now]'),
      priceWas: root.querySelector('[data-price-was]'),
      priceSave: root.querySelector('[data-price-save]'),
      atc: root.querySelector('[data-atc]'),
      atcNote: root.querySelector('[data-atc-note]'),
      empty: root.querySelector('[data-stage-empty]'),
      placeholder: root.querySelector('.stage__placeholder'),
      errors: root.querySelector('[data-errors]')
    };

    /* group the pre-rendered stage layers by variant */
    this.layers = this.variants.map(function (v, i) {
      return Array.prototype.slice.call(
        root.querySelectorAll('[data-stage] img[data-variant="' + i + '"]')
      );
    });

    this.tier = 0;
    this.picks = [0];
    this.activeSlot = 0;
    this.shot = 0;

    this.bind();
    this.setTier(0);
  }

  WoovoBuybox.prototype.bind = function () {
    var self = this;

    Array.prototype.forEach.call(this.el.swatches, function (btn, i) {
      btn.querySelector('img').src = self.variants[i].images[0] || '';
      btn.addEventListener('click', function () { self.pick(i); });
      btn.addEventListener('keydown', self.arrows(self.el.swatches, i, function (n) { self.pick(n); }));
    });

    Array.prototype.forEach.call(this.el.tierEls, function (btn, i) {
      btn.addEventListener('click', function () { self.setTier(i); });
      btn.addEventListener('keydown', self.arrows(self.el.tierEls, i, function (n) { self.setTier(n); }));
    });

    Array.prototype.forEach.call(this.root.querySelectorAll('[data-add]'), function (btn) {
      btn.addEventListener('click', function () { self.addToCart(btn, btn.hasAttribute('data-buy-now')); });
    });

    /* sticky bar shows once the buy box has scrolled past the top */
    var sticky = document.querySelector('[data-woovo-sticky="' + (this.root.dataset.sectionId || '') + '"]');
    if (sticky) {
      this.sticky = {
        bar: sticky,
        name: sticky.querySelector('[data-sticky-name]'),
        price: sticky.querySelector('[data-sticky-price]'),
        thumb: sticky.querySelector('[data-sticky-thumb]'),
        swatches: sticky.querySelector('[data-sticky-swatches]')
      };
      if (this.sticky.swatches && !this.singleVariant && this.variants.length > 1) {
        this.variants.forEach(function (v, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'sticky__chip';
          b.setAttribute('role', 'radio');
          b.setAttribute('aria-label', v.name);
          b.title = v.name;
          var im = document.createElement('img');
          im.src = v.images[0] || '';
          im.alt = '';
          b.appendChild(im);
          b.addEventListener('click', function () { self.pick(i); });
          self.sticky.swatches.appendChild(b);
        });
      }
      Array.prototype.forEach.call(sticky.querySelectorAll('[data-add]'), function (btn) {
        btn.addEventListener('click', function () { self.addToCart(btn, btn.hasAttribute('data-buy-now')); });
      });
      var pass = function () {
        sticky.classList.toggle('show', self.root.getBoundingClientRect().bottom < 90);
      };
      window.addEventListener('scroll', pass, { passive: true });
      window.addEventListener('resize', pass, { passive: true });
      pass();
    }
  };

  WoovoBuybox.prototype.arrows = function (list, idx, cb) {
    return function (e) {
      var d = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1
            : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
      if (!d) return;
      e.preventDefault();
      var n = (idx + d + list.length) % list.length;
      cb(n);
      list[n].focus();
    };
  };

  /* --- gallery ------------------------------------------------ */

  WoovoBuybox.prototype.showShot = function (n) {
    this.shot = n;
    var row = this.layers[this.current] || [];
    row.forEach(function (img, i) { img.classList.toggle('on', i === n); });
    Array.prototype.forEach.call(this.el.thumbs.children, function (t, i) {
      t.setAttribute('aria-current', i === n ? 'true' : 'false');
    });
    var v = this.variants[this.current];
    var shot = v.shots && v.shots[n] ? v.shots[n].trim() : '';
    if (this.singleVariant) this.el.tag.textContent = shot;
    else this.el.tag.textContent = shot ? v.name + ' — ' + shot : v.name;
    this.el.tag.hidden = !this.el.tag.textContent;
  };

  WoovoBuybox.prototype.select = function (i) {
    var self = this;
    (this.layers[this.current] || []).forEach(function (img) { img.classList.remove('on'); });
    this.current = i;
    var v = this.variants[i];

    Array.prototype.forEach.call(this.el.swatches, function (btn, w) {
      btn.setAttribute('aria-checked', w === i ? 'true' : 'false');
      btn.tabIndex = w === i ? 0 : -1;
    });

    /* rebuild the thumb strip for this design */
    this.el.thumbs.textContent = '';
    v.images.forEach(function (src, t) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'thumb';
      b.setAttribute('aria-current', t === 0 ? 'true' : 'false');
      var label = v.shots && v.shots[t] ? v.shots[t].trim() : 'photo ' + (t + 1);
      b.setAttribute('aria-label', 'View ' + v.name + ', ' + label);
      var im = document.createElement('img');
      im.src = src;
      im.alt = '';
      im.loading = 'lazy';
      b.appendChild(im);
      b.addEventListener('click', function () { self.showShot(t); });
      b.addEventListener('keydown', self.arrows(self.el.thumbs.children, t, function (n) {
        self.showShot(n);
      }));
      self.el.thumbs.appendChild(b);
    });

    var noPhotos = v.images.length === 0;
    if (this.el.empty) this.el.empty.hidden = !noPhotos;
    if (this.el.placeholder) this.el.placeholder.style.display = noPhotos ? '' : 'none';
    this.el.thumbs.hidden = v.images.length < 2;

    if (this.el.optVal) this.el.optVal.textContent = v.color ? v.name + ' — ' + v.color : v.name;
    this.el.vdesc.textContent = v.desc || '';
    this.showShot(0);
  };

  /* --- set building ------------------------------------------- */

  WoovoBuybox.prototype.pick = function (i) {
    this.picks[this.activeSlot] = i;
    this.select(i);
    this.renderSlots();
    this.renderSummary();
  };

  WoovoBuybox.prototype.renderSlots = function () {
    var self = this;
    var multi = this.tiers[this.tier].qty > 1 && !this.singleVariant;
    this.el.slots.hidden = !multi;
    if (this.el.mixnote) this.el.mixnote.hidden = !multi;
    if (this.el.designLabel) this.el.designLabel.textContent = multi ? 'Design for each paddle' : 'Design';
    if (!multi) { this.el.slots.textContent = ''; return; }

    this.el.slots.textContent = '';
    this.picks.forEach(function (variantIndex, idx) {
      var v = self.variants[variantIndex];
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'slot';
      b.setAttribute('aria-current', idx === self.activeSlot ? 'true' : 'false');
      b.setAttribute('aria-label', 'Paddle ' + (idx + 1) + ': ' + v.name + '. Change it.');
      var im = document.createElement('img');
      im.src = v.images[0] || '';
      im.alt = '';
      im.loading = 'lazy';
      b.appendChild(im);
      b.appendChild(document.createTextNode(v.name));
      b.addEventListener('click', function () {
        self.activeSlot = idx;
        self.select(variantIndex);
        self.renderSlots();
      });
      self.el.slots.appendChild(b);
    });
  };

  WoovoBuybox.prototype.setTier = function (n) {
    var self = this;
    this.tier = n;
    var qty = this.tiers[n].qty;
    while (this.picks.length > qty) this.picks.pop();
    while (this.picks.length < qty) {
      var next = 0;
      for (var c = 0; c < this.variants.length; c++) {
        if (self.picks.indexOf(c) === -1) { next = c; break; }
      }
      this.picks.push(next);
    }
    this.activeSlot = 0;
    this.select(this.picks[0]);
    this.renderSlots();
    this.renderSummary();
  };

  WoovoBuybox.prototype.renderSummary = function () {
    var self = this;
    var t = this.tiers[this.tier];
    /* work from the real variant prices so the buy box can never quote a
       number the cart will not honour */
    var pct = t.percent || 0;
    var full = this.picks.reduce(function (sum, p) { return sum + self.variants[p].price; }, 0);
    /* round per unit, the way Shopify rounds each line item */
    var total = this.picks.reduce(function (sum, p) {
      return sum + Math.round(self.variants[p].price * (100 - pct) / 100);
    }, 0);
    var saved = full - total;
    var each = t.qty ? Math.round(total / t.qty) : total;

    this.el.priceNow.textContent = money(total, this.moneyFormat);
    this.el.priceWas.textContent = saved > 0 ? money(full, this.moneyFormat) : '';
    this.el.priceWas.hidden = saved <= 0;
    /* a percentage reads the same in every currency; an amount converts */
    var savedLabel = this.savingsAs === 'amount' ? money(saved, this.moneyFormat) : pct + '%';
    this.el.priceSave.textContent = saved > 0
      ? 'Save ' + savedLabel
      : t.no_saving_label || 'Free shipping';

    this.el.tierVal.textContent = t.label;
    this.el.atc.textContent = (t.qty === 1 ? 'Add to cart — ' : 'Add ' + t.qty + ' paddles — ')
      + money(total, this.moneyFormat);
    if (this.el.atcNote) {
      this.el.atcNote.textContent = t.qty === 1
        ? t.note_single || ''
        : money(each, this.moneyFormat) + ' per paddle · ships together';
    }

    Array.prototype.forEach.call(this.el.tierEls, function (el, i) {
      el.setAttribute('aria-checked', i === self.tier ? 'true' : 'false');
      el.tabIndex = i === self.tier ? 0 : -1;
    });

    if (this.sticky) {
      this.sticky.name.textContent = t.qty === 1
        ? this.variants[this.picks[0]].name
        : t.name + ' — ' + t.qty + ' paddles';
      if (t.qty === 1 && this.singleVariant) {
        this.sticky.name.textContent = this.variants[this.picks[0]].name;
      }
      this.sticky.price.textContent = money(total, this.moneyFormat)
        + (saved > 0 ? ' \u00b7 save ' + savedLabel : '');
      this.sticky.thumb.src = this.variants[this.picks[0]].images[0] || '';
      if (this.sticky.swatches) {
        Array.prototype.forEach.call(this.sticky.swatches.children, function (chip, i) {
          chip.setAttribute('aria-checked', i === self.current ? 'true' : 'false');
        });
      }
    }

    /* any sold-out design in the set blocks the button */
    var soldOut = this.picks.filter(function (p) { return !self.variants[p].available; });
    this.el.atc.disabled = soldOut.length > 0;
    var buyNow = this.root.querySelector('[data-buy-now]');
    if (buyNow) buyNow.disabled = soldOut.length > 0;
    if (soldOut.length === 1) {
      this.el.atc.textContent = this.variants[soldOut[0]].name + ' is sold out';
    } else if (soldOut.length > 1) {
      this.el.atc.textContent = 'Some designs are sold out';
    }
  };

  /* --- cart --------------------------------------------------- */

  WoovoBuybox.prototype.addToCart = function (btn, checkout) {
    var self = this;
    var t = this.tiers[this.tier];
    var setId = 'woovo-' + Date.now().toString(36);
    var label = btn.textContent;

    var items = this.picks.map(function (variantIndex, i) {
      var props = { 'Design': self.variants[variantIndex].name };
      if (t.qty > 1) {
        props['_set_id'] = setId;
        props['Set'] = t.name;
        props['Paddle'] = (i + 1) + ' of ' + t.qty;
      }
      return { id: self.variants[variantIndex].id, quantity: 1, properties: props };
    });

    btn.disabled = true;
    btn.textContent = 'Adding…';
    if (this.el.errors) { this.el.errors.hidden = true; this.el.errors.textContent = ''; }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart');
        if (checkout) {
          btn.textContent = 'Taking you to checkout…';
          window.location.href = window.Shopify.routes.root + 'checkout';
          return;
        }
        btn.textContent = 'Added';
        /* /cart/add.js returns what was added, not the cart total, so ask */
        fetch(window.Shopify.routes.root + 'cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('woovo:cart-updated', {
              detail: { count: cart.item_count }
            }));
          })
          .catch(function () { /* bubble just stays as it was */ });
        self.refreshCart();
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1600);
      })
      .catch(function (err) {
        btn.textContent = label;
        btn.disabled = false;
        if (self.el.errors) {
          self.el.errors.hidden = false;
          self.el.errors.textContent = err.message;
        }
      });
  };

  /* nudge Dawn's cart drawer / bubble to re-read the cart */
  WoovoBuybox.prototype.refreshCart = function () {
    var drawer = document.querySelector('cart-drawer');
    var sections = ['cart-drawer', 'cart-icon-bubble', 'cart-live-region-text'];
    fetch(window.Shopify.routes.root + '?sections=' + sections.join(','))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        sections.forEach(function (id) {
          if (!data[id]) return;
          var incoming = new DOMParser().parseFromString(data[id], 'text/html');
          var source = incoming.querySelector('#shopify-section-' + id) || incoming.body.firstElementChild;
          var target = document.getElementById('shopify-section-' + id)
            || document.getElementById(id)
            || document.querySelector('.' + id);
          if (source && target) target.innerHTML = source.innerHTML;
        });
        if (drawer && typeof drawer.open === 'function') drawer.open();
      })
      .catch(function () { /* cart still updated server-side; drawer just won't auto-open */ });
  };

  function init() {
    document.querySelectorAll('[data-woovo-buybox]').forEach(function (el) {
      new WoovoBuybox(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
